<div class="topup-result-container">
    <div class="topup-result-card">
        <span class="material-icons success-icon">check_circle</span>
        <h2>{{'TopupSim.successTitle' | translate}}</h2>
        <p>{{'TopupSim.successMessage' | translate}}</p>
        <p class="redirect-text">{{'TopupSim.redirectingIn' | translate}} {{countdown}}s</p>
        <button mat-raised-button color="primary" (click)="goToDevices()">
            {{'TopupSim.backToDevices' | translate}}
        </button>
    </div>
</div>